/**************************************************
 * Nombre:       Formulario_Anuncios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {DragHandleOutlined, Facebook, Instagram, TitleOutlined} from "@mui/icons-material";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";

const Formulario_Anuncios = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCrop dato={'img'} alto={6} ancho={9} {...props}  />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 14}}>**Imagen de 900px por 600px de menos de 400K de peso</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo de Publicacion'}
                                  dato={'titulo'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={3} nombre={'Descripcion'}
                                  dato={'descripcion'} {...props}
                        />

                < /Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={DragHandleOutlined} nombre={'Sub Titulo'}
                                  dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto Icono={Instagram} nombre={'Link Instragram'} dato={'instagram'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Facebook} nombre={'Link Facebook'} dato={'facebook'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto nombre={'Link Tiktok'} dato={'tiktok'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

)

}
export default Formulario_Anuncios